// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-bottom-nav[data-v-18f31f57]{z-index:4}", ""]);
// Exports
module.exports = exports;
